import { gql } from '@apollo/client'
import { MUTATION_STATE, VOOH_MEDIA_FIELDS } from 'api/fragments'

const PAYLOAD_TYPE = 'CreateVoohMediaTemplatePayload'

export const CREATE_VOOH_MEDIA_TEMPLATE = gql`
  ${MUTATION_STATE(PAYLOAD_TYPE)}
  ${VOOH_MEDIA_FIELDS}
  mutation createVoohMediaTemplate($name: String!, $mediaIds: [ID!]!) {
    createVoohMediaTemplate(input: { name: $name, mediaIds: $mediaIds }) {
      template {
        id
        media {
          ...VoohMediumFields
        }
        name
      }
      ...MutationState${PAYLOAD_TYPE}Fields
    }
  }
`
